/**
 * The Downloads tab's ground: a shade deeper than the other professional tabs, so
 * the white lookbook covers and file rows stand off it. The route handle hands it
 * to the profile shell, which sets it as `--ground`, so the tab bar and every
 * `bg-ground` band on the tab take it.
 */
export const DOWNLOADS_GROUND_COLOUR = '#ebebed';
